import { CasinoCategorySeoContext, CasinoLobbyCategory } from "../../http/protocol";
import { SingleTargetSeoDraft, SingleTargetSeoServiceType } from "./singleTargetSeoDraft";

/** The part of the casino category service the draft loads and saves through. */
export type CasinoCategorySeoServiceType = SingleTargetSeoServiceType<CasinoCategorySeoContext>;

/** The SEO values being edited for one casino category, sent once the category itself is saved. */
export class CasinoCategorySeoDraft extends SingleTargetSeoDraft<CasinoCategorySeoContext> {
  saveAfterCategorySave(savedCategory: CasinoLobbyCategory): Promise<void> {
    return this.saveAfterTargetSave(savedCategory.id);
  }
}
